import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URLS, PLATFORM_TYPE } from '../constants/constants';
import { parseJwt } from "../components/utilities/utils";
// import { Pokemon } from './types'



//const roles= "ceo";

// Define a service using a base URL and expected endpoints
export const nullificationServicesApi = createApi({
  reducerPath: "nullificationServicesApi",
  tagTypes:['Nullification','Request'],
  keepUnusedDataFor:0.001,
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URLS.NULLIFICATION_BASE_URL ,
  prepareHeaders: (headers) => {
    headers.set("authorization", `Bearer ${localStorage.access_token}`);
    headers.set("currentRole", localStorage.userrole);
    headers.set("atkn_bnd", localStorage?.atkn_bnd);
      headers.set("rtkn_bnd", localStorage?.rtkn_bnd);
      headers.set("channelidobo", "ETPBMS");
      headers.set("PLATFORM-TYPE", PLATFORM_TYPE);
    if(localStorage.userrole !== "eci" && localStorage.userrole !== "epba")
    {
      headers.set("statecd", parseJwt(localStorage.access_token)?.authorizedStates?.[0]);
      headers.set("atkn_bnd", localStorage?.atkn_bnd);
      headers.set("rtkn_bnd", localStorage?.rtkn_bnd);
      headers.set("channelidobo", "ETPBMS");
    }
    return headers;
  },
}),
  endpoints: (builder) => ({
   
    
    /******** Nullification Get All States  */

    getAllState: builder.query({
      query: () => ({
        url: "v1/public/commonMaster/states",
        method: "GET",
      }),
    }),

    
   
    /******** Nullification Fetch Constituiencies  */

    // getAllFetch: builder.query({
    //   query: () => ({
    //     url: "/v1/public/commonMaster/constituencies",
    //     method: "GET",
    //     headers: {
    //      // 'Authorization': 'Bearer ' + localStorage.access_token,
    //       'Content-Type': 'application/json',
    //     //  'currentrole' : localStorage.userrole,
    //     //   'state': parseJwt(localStorage.access_token).authorizedStates[0],
    //    },
    //   }),
    // }),

    // /******** Nullification Election Constituiencies  */

    // getAllElection: builder.query({
    //   query: () => ({
    //     headers: {
    //       //'Authorization': 'Bearer ' + localStorage.access_token,
    //       'Content-Type': 'application/json',
    //     //  'currentrole' : localStorage.userrole,
    //     //   'state': parseJwt(localStorage.access_token).authorizedStates[0],
    //    },
    //     url: "/v1/public/commonMaster/electionTypes",
    //     method: "GET",
    //   }),
    // }),

    // /******** Nullification Election Constituiencies  */

    // getConstituencyById: builder.query({
    //   query: (id) => ({
    //     url: `v1/public/commonMaster/asmblyConstituencies/${id}`,
    //     method: "GET",
    //   }),
    // }),

    getAllCommonMaster: builder.query({
      query: () => ({
        headers: {
        //   'Authorization': 'Bearer ' + localStorage.access_token,
        'Content-Type': 'application/json',
        // 'currentrole' : localStorage.userrole,
        // 'state': parseJwt(localStorage.access_token).authorizedStates[0],
       },
        url: "/v1/public/nullify/getCommonData",
        method: "GET",
      }),
    }),

    /******** Nullification Request Submit Data  */

    nullification: builder.mutation({
    
      query: (body) =>( {
        headers: {
          // 'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
        //  'currentrole' : localStorage.userrole,
        //   'state': parseJwt(localStorage.access_token).authorizedStates[0],
       },
          url: "/v1/public/nullify/submitnullifieddata",
          method: "POST",
          body: body,
      }),
    }),

    /******** Nullification Get Data For Nullifications  */

    getAllNullification: builder.query({
      query: () => ({
        url: (localStorage?.userrole==="ceo"||localStorage?.userrole==="ceoa")?`/v1/public/nullify/getDataForNullifications`:(localStorage?.userrole==="eci" ||localStorage?.userrole==="epba" ||localStorage?.userrole==="epbr")?`/v1/public/nullify/getAllStateDataForNullifications`:"",
        method: "GET",
      }),
      providesTags:['Nullification','Request']
    }),

   
    /******** Nullification Reject by Id */
   
    getRejectById: builder.query({
      query: (id) => ({
        url: `/v1/public/nullify/getDataForNullification/${id}`,
        method: "GET",
      }),
      providesTags:['Nullification','Request']
    }),

    /******** Nullification Reject */

    UserUpdate: builder.mutation({
     
      query: (data1) => ({
        headers: {
          // 'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
        //  'currentrole' : localStorage.userrole,
        //   'state': parseJwt(localStorage.access_token).authorizedStates[0],
       },
        url: `/v1/public/nullify/rejectNullificationData`,
        method: "POST",
        body: data1,
      }),
      invalidatesTags:['Nullification']
    }),

    /******** Nullification APPROVE */
    UserApprove: builder.mutation({
   
      query: (data) => ({
        headers: {
          // 'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
      //    'currentrole' : localStorage.userrole,
      //     'state':parseJwt(localStorage.access_token).authorizedStates[0],
        },
        url: `/v1/public/nullify/approveNullificationData`,
        method: "POST",
        body: data,
      }),
      invalidatesTags:['Nullification']
    }),
   
  }),
});


export const {
useUserApproveMutation,
useGetRejectByIdQuery,
useUserUpdateMutation,
useGetAllNullificationQuery,
useNullificationMutation,
// useGetConstituencyByIdQuery,
// useGetAllElectionQuery,
// useGetAllFetchQuery,
useGetAllStateQuery,
useGetAllCommonMasterQuery
  
 } = nullificationServicesApi;
